<template>
  <div class="h-screen">
    <section ref="section9" class="mx-auto flex h-full flex-col">
      <v-register-head
        @previous="8"
        :step="9"
        :landing-route="registrationProcessData.routes.landing"
      ></v-register-head>
      <div
        class="flex h-full flex-col items-center justify-between px-4 py-8 md:px-12"
      >
        <form
          method="POST"
          :action="registrationProcessData.routes.processUploadCustomerImage"
          id="upload-customer-image-form"
          enctype="multipart/form-data"
        >
          <v-csrf-token></v-csrf-token>
          <input
            type="file"
            accept="image/png, image/jpeg, image/jpg"
            name="image"
            ref="file"
            @change="onFileChange"
            style="display: none"
          />
          <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
            <figure class="flex gap-3">
              <div><v-icon icon="id" size="8"></v-icon></div>
              <div class="flex flex-col justify-center">
                <div class="mb-3 text-heading-3-desktop">
                  Izpolnite svoje osebne podatke
                </div>
                <div class="text-body-regular text-black-40">
                  Želimo si vas bolje spoznati
                </div>
              </div>
            </figure>
            <figure class="mx-auto flex max-w-[240px] flex-col gap-8">
              <img
                class="lazy mx-auto h-[240px] w-[240px] rounded-full shadow"
                :src="profileImg"
              />
              <figure class="flex flex-col gap-4">
                <a class="button h-[48px] px-6" @click="$refs.file.click()">
                  <label class="text-small-text-medium">Naložite sliko</label>
                  <v-icon icon="upload" size="4"></v-icon>
                </a>
              </figure>
            </figure>
          </figure>
        </form>
      </div>
      <div class="flex h-full max-h-[102px] justify-between border-t px-4 pt-4">
        <div class="flex w-full justify-center">
          <a
            @click="submitForm('upload-customer-image-form')"
            class="button button--form"
          >
            <label class="text-small-text-medium">Nadaljujte</label>
            <v-icon icon="arrow-right" size="4"></v-icon>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    registrationProcessData: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    session: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
        profileImg: '/assets/images/profile.webp'
    };
  },
  computed: {},
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.profileImg = URL.createObjectURL(file);
    },
    submitForm(formId) {
      document.getElementById(formId).submit();
    },
  },
};
</script>
